import { NgModule, Type, Provider } from "@angular/core";

import * as CoreDirectives from "./core/directives/index";

// Module

// Exports
const mExports: Array<Type<any> | any[]> = [
  CoreDirectives.CoreImagesDirective,
  CoreDirectives.CoreVideoDirective,
];

// Provider
const providers: Provider[] = [
];

// Deklarationen for modal dialog Component
const entryComponents: Array<Type<any> | any[]> = [
];

// Deklarationen
const declarations: Array<Type<any> | any[]> = [
  CoreDirectives.CoreImagesDirective,
  CoreDirectives.CoreVideoDirective
];

// Modul
const ngModule: NgModule = {
  declarations: declarations,
  entryComponents: entryComponents,
  exports: mExports,
  providers: providers,
};

@NgModule(ngModule)
export class SharedModule {
  constructor() { }
}
